<template>
    <svg width="104" height="104" viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M81.25 22.75L22.75 81.25" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M81.25 81.25L22.75 22.75" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>